import { useNavigate } from "react-router-dom";
import styles from "./CompanyHeader.module.css";

import { IssuerDate  } from "../../Utils/helper";

const CompanyHeader = ({ companyProfile, user_type }) => {
  const navigate = useNavigate();
  let isLoading = true
  if(companyProfile?.name==null){
    isLoading = true
  }
  else{
    isLoading = false
  }

  return (
    <div className={styles.h1}>
      <div className={styles.heading}>
        <div className={styles.heading}>
          <div className={styles.button} onClick={()=>navigate("/Dashboard")}>
            <img className={styles.arrowLeftIcon} loading="eager" alt="" src="/arrowleft.svg"/>
          </div>
          <div className={styles.buttonBase}>
            {isLoading ? (
              <span>?</span>
            ) : companyProfile?.logo_path ? (
              <img src={companyProfile.logo_path} style={{ height: '2rem', borderRadius: '0.5rem' }} alt="Company Logo" />
            ) : (
              <span>{companyProfile?.name ? companyProfile.name.charAt(0) : `?`}</span>
            )}
          </div>
          <div className={styles.text}>
            <h2 className={styles.navitem}>
              {isLoading ? <div className="shimmer" style={{width:"5rem"}}></div> : companyProfile.name ? companyProfile.name : `N/A`}
            </h2>
          </div>
        </div>
      </div>
      <div className={styles.profilecardoutline}>
        <div className={styles.line}>
          <div className={styles.text1}>Added on</div>
          <div className={styles.text3}>
            {isLoading ? <div className="shimmer"></div> : <IssuerDate dateString={companyProfile.created_at} />}
          </div>
        </div>
        <div className={styles.line}>
          <div className={styles.text1}>Email</div>
          <div className={styles.text3}>{isLoading ? <div className="shimmer"></div> : companyProfile.email}</div>
        </div>
        <div className={styles.line}>
          <div className={styles.text1}>Phone</div>
          <div className={styles.text3}>{isLoading ? <div className="shimmer"></div> : companyProfile.phone_number}</div>
        </div>
        <div className={styles.line}>
          <div className={styles.text1}>Type</div>
          <div className={styles.text3}>{isLoading ? <div className="shimmer"></div> : companyProfile?.user_type || user_type}</div>
        </div>
        <div className={styles.line}>
          <div className={styles.text1}>Status</div>
          <div className={styles.text3}>{isLoading ? <div className="shimmer"></div> : companyProfile.issuer_state || companyProfile.user_state}</div>
        </div>
      </div>
    </div>
  );
};

export default CompanyHeader;
